module.exports = __webpack_public_path__ + "img/shareImg1.24cbe378.png";